<template>
  <div class="hitwrapper syllabus">
    <div class="code">{{ hit.eduCode }}</div>
    <div class="hittitle">
      <a :href="hit.url">
        {{ hit.title }},
        {{ hit.credits }}
        <Icon type="arrow-right"/>
      </a>
    </div>
  </div>
</template>
<script>
import Icon from "../../../image/icon.vue";
export default {
  name: "SyllabusItem",
  props: {
    hit: Object,
  },
  components: {
    Icon,
  },
};
</script>
